import React from 'react';
import { Route } from 'react-router';
import Logout from '../../components/Logout';


const routes = <Route path="logout" component={Logout} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/logout.js